import { useMobile } from '@/hooks/useMobile'
import { classes, type Children } from '@lc/libreact'
import { useEffect, useRef, useState } from 'react'
import { AssetSvg } from '../foundation/Svg'
import styles from './ModuleContainer.scss'

export function ModuleContainer({ children }: { children: Children }) {
	return <div className={styles.container}>{children}</div>
}

export function ScrollableContent({
	children,
	className,
}: {
	children: Children
	className?: string
}) {
	const mobile = useMobile()
	const scrollableRef = useRef<HTMLDivElement>(null)
	const [showArrow, setShowArrow] = useState(false)

	const handleScroll = () => {
		if (scrollableRef.current) {
			setShowArrow(scrollableRef.current.scrollTop > 80)
		}
	}
	const scrollToTop = () => {
		scrollableRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
	}

	useEffect(() => {
		if (scrollableRef.current) {
			scrollableRef.current.addEventListener('scroll', handleScroll)
		}

		return () => {
			if (scrollableRef.current) {
				scrollableRef.current.removeEventListener(
					'scroll',
					handleScroll,
				)
			}
		}
	}, [])

	return (
		<div
			ref={scrollableRef}
			className={classes(styles.content, className)}
			id="content"
			tabIndex={-1}
		>
			{children}
			{showArrow && mobile && (
				<button
					type="button"
					onClick={() => scrollToTop()}
					className={styles.chevron}
				>
					<AssetSvg
						name={'assets/Chevron.svg'}
						className={styles.pictoChevron}
					/>
				</button>
			)}
		</div>
	)
}
